import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../services/AuthProvider";
import AuthBtn from "../../../Utils/AuthBtn/AuthBtn";
import Banner from "../../../Utils/Banner/Banner";
import OtpInput from "../../../Utils/OtpInput/OtpInput";

export default function OtpVerify() {
  const { validateOtp, navigatePage } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    navigatePage === "createPassword" && navigate("/create-password");
  }, [navigatePage]);

  return (
    <section className="w-full h-full">
      <Banner heading={`Work Flexibly`} />
      <OtpInput />
      <AuthBtn clickFunction={validateOtp} />
    </section>
  );
}
